import React from 'react';
import PropTypes from 'prop-types';

const Loading = props => (
  <div className="loading_dynamic_list">
    <div className="lds-roller">
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  </div>
);

export default Loading;



// WEBPACK FOOTER //
// ./source/client/components/account_list/loading.jsx